<template>
  <div class="head">
    <div class="header">
      <div class="title_log"><img src="../static/title_logo.png" alt="" /></div>
      <div class="left" v-if="lang == 'zh'">
        <div class="img"><img src="../static/logo.png" alt="" /></div>
        <div class="txt">
          <p class="p1">{{ $t("navbar.title") }}</p>
          <p class="p2">{{ $t("navbar.theme") }}</p>
          <p class="p3">{{ $t("navbar.time") }}</p>
        </div>
      </div>
      <div
        class="center"
        :style="{
          marginLeft:
            isLowScreen == true ? (lang == 'en' ? '3px' : '240px') : '6%',
        }"
      >
        <ul>
          <router-link
            to="index"
            class="hyperlinks"
            :style="{
              marginLeft:
                isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
            }"
            ><li>{{ $t("navbar.home") }}</li></router-link
          >
          <router-link
            to="exhibition"
            class="hyperlinks"
            :style="{
              marginLeft:
                isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
            }"
            ><li
              :style="{
                color: active['exhibition'] === true ? '#FDD000' : '#fff',
              }"
            >
              {{ $t("navbar.exhibition") }}
            </li></router-link
          >
          <router-link
            to="exhibitsList"
            class="hyperlinks"
            :style="{
              marginLeft:
                isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
            }"
            ><li
              :style="{
                color: active['exhibitsList'] === true ? '#FDD000' : '#fff',
              }"
            >
              {{ $t("navbar.exhibits") }}
            </li></router-link
          >
          <router-link
            to="live"
            class="hyperlinks"
            :style="{
              marginLeft:
                isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
            }"
            ><li
              :style="{ color: active['live'] === true ? '#FDD000' : '#fff' }"
            >
              {{ $t("navbar.live") }}
            </li></router-link
          >
          <router-link
            to="active"
            class="hyperlinks"
            :style="{
              marginLeft:
                isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
            }"
            ><li
              :style="{ color: active['active'] === true ? '#FDD000' : '#fff' }"
            >
              {{ $t("navbar.activity") }}
            </li></router-link
          >
          <router-link
            to="#"
            class="hyperlinks"
            :style="{
              marginLeft:
                isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
            }"
            ><li class="li">
              {{ $t("navbar.onlineHall") }}
              <div class="menu">
                <router-link to="#"
                  ><p @click="routerLink('vr')">
                    {{ $t("navbar.VRview") }}
                  </p></router-link
                >
                <router-link to="#"
                  ><p @click="routerLink('imgView')">
                    {{ $t("navbar.imgView") }}
                  </p></router-link
                >
                <router-link to="#"
                  ><p @click="routerLink('videoView')">
                    {{ $t("navbar.videoView") }}
                  </p></router-link
                >
              </div>
            </li>
          </router-link>
          <!-- :href="hzZhanhui" -->
          <a
            class="hyperlinks"
            @click="goGW"
            target="_blank"
            :style="{
              marginLeft:
                isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
            }"
            ><li>{{ $t("navbar.onlineWeb") }}</li></a
          >
        </ul>
      </div>
      <div
        class="right"
        :style="{
          marginLeft:
            isLowScreen == true ? (lang == 'en' ? '1px' : '26px') : '26px',
        }"
      >
        <div
          :class="hasViewToken ? 'login1' : 'login'"
          @click="logins(1)"
          :style="{
            padding: lang == 'zh' ? '0px 17px ' : '0px 3px',
            boxSizing: 'boder-box',
          }"
        >
          {{
            hasViewToken
              ? $t("navbar.audienceCenter")
              : $t("navbar.audienceLogin")
          }}
        </div>
        <div
          :class="hasToken ? 'login1' : 'login'"
          @click="logins(2)"
          :style="{
            padding: lang == 'zh' ? '0px 17px ' : '0px 3px',
            boxSizing: 'boder-box',
          }"
        >
          {{
            hasToken
              ? $t("navbar.exhibitionCenter")
              : $t("navbar.exhibitionLogin")
          }}
        </div>
        <div
          class="language"
          @click="changeLang()"
          :style="{
            marginLeft:
              isLowScreen == true ? (lang == 'en' ? '1px' : '3px') : '5px',
          }"
        >
          <div class="chese" v-if="toggle">
            {{ $t("navbar.zh") }}
          </div>
          <div class="english" v-else>
            {{ $t("navbar.en") }}
          </div>
          <!-- <div class="chese" v-if="toggle">
            <img src="../static/ico-chinese.png" />{{ $t("navbar.zh") }}
          </div>
          <div class="english" v-else>
            <img src="../static/ico-english.png" />{{ $t("navbar.en") }}
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as tools from "../../utils/roulink";
import {
  hzExhibitionLogin,
  hzAudienceLogin,
  hzExhibitionIndex,
  hzAudienceIndex,
  hzZhanhui,
  testDomain,
} from "../../utils/common.js";
export default {
  name: "headTop",
  data() {
    return {
      loginUrl: hzExhibitionLogin(),
      audienceLoginUrl: hzAudienceLogin(),
      hzExhibitionIndex: hzExhibitionIndex(),
      audienceIndex: hzAudienceIndex(),
      toggle: false, //开关按钮1
      hasToken: false,
      active: {},
      hzZhanhui: hzZhanhui(),
      lang: "zh",
      isLowScreen: false,
      testBaseDomain: testDomain(),
    };
  },
  created() {
    const currentToken = localStorage.getItem("token");
    if (currentToken) {
      this.hasToken = true;
    } else {
      this.hasToken = false;
    }
    const currentToken1 = localStorage.getItem("viewToken");
    if (currentToken1) {
      this.hasViewToken = true;
    } else {
      this.hasViewToken = false;
    }
    this.isActive();
    const language = localStorage.getItem("lang");
    this.$i18n.locale = language == "en" ? language : "zh";
    this.lang = language ? language : "zh";
    this.toggle = language == "en" ? true : false;

    if (language !== "en") {
      localStorage.setItem("lang", "zh");
    }
    if (document.body.clientWidth <= 1680) {
      // 低分辨率
      this.isLowScreen = true;
    }
  },
  methods: {
    goGW() {
      window.openGwDia();
    },
    routerLink(flag) {
      let routerUrl;
      if (flag == "vr") {
        routerUrl = this.testBaseDomain + "index?slanguage=" + this.lang;
      }
      if (flag == "imgView") {
        routerUrl =
          this.testBaseDomain + "index?pop=photo&slanguage=" + this.lang;
      }
      if (flag == "videoView") {
        routerUrl =
          this.testBaseDomain + "index?pop=video&slanguage=" + this.lang;
      }
      window.open(routerUrl);
    },
    changeLang(e) {
      if (this.toggle == true) {
        // 当前显示的是中文图标,说明页面内容是英文,
        // todo: 把图标变为英文图标，内容变为中文
        this.toggle = false;
        localStorage.setItem("lang", "zh");
        this.$i18n.locale = "zh";
        this.lang = "zh";
        // 存到localStorage的语言是zh
      } else if (this.toggle == false) {
        // 当前显示的是英文图标,说明页面内容是中文,
        // todo: 把图标变为中文图标，内容变为英文
        this.toggle = true;
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        this.lang = "en";
        // 存到localStorage的语言是en
      }
      window.location.reload();
    },
    isActive() {
      const key = window.location.href.split("#")[1].slice(1);
      if (window.location.href.includes("exhibItem_detail")) {
        this.active.exhibitsList = true;
      }
      if (window.location.href.includes("exhibition_det")) {
        this.active.exhibition = true;
      }
      if (window.location.href.includes("active")) {
        this.active.active = true;
      }
      if (window.location.href.includes("live_detail")) {
        this.active.live = true;
      }
      if (window.location.href.includes("news_detail")) {
        this.active.exhibition = true;
      }
      this.active[key] = true;
    },
    control() {
      if (this.toggle == true) {
        this.toggle = false;
      } else {
        this.toggle = true;
      }
    },
    logins(val) {
      tools.login(val);
    },
    // zsLogin() {
    //   // 展商登录
    //   const isToken = localStorage.getItem('viewToken');
    //   const zsToken = localStorage.getItem('token');
    //   if (isToken) {
    //     this.$message.error('只能登录一个账号!');
    //     return;
    //   } else if (!zsToken) {
    //     window.open(this.loginUrl);
    //   } else {
    //     window.open(this.hzExhibitionIndex);
    //   }
    // },
    // login() {
    //   // 观众登录
    //   const isToken = localStorage.getItem('viewToken');
    //   const zsToken = localStorage.getItem('token');
    //   if (zsToken) {
    //     this.$message.error('只能登录一个账号!');
    //     return;
    //   } else if (!isToken) {
    //     window.location.replace(this.audienceLoginUrl);
    //   } else {
    //     window.open(this.audienceIndex);
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  height: 100px;
  min-width: 1270px !important;
  background-color: rgba(0, 111, 184);
  opacity: 1;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99;
  .header {
    width: 1270px;
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 auto;
    .left {
      display: none;
      justify-content: flex-start;
      align-items: center;
      .img {
        width: 87px;
        height: 86px;
      }
      .txt {
        width: 440px;
        margin-left: 15px;

        .p1 {
          display: block;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ffffff;
          line-height: 26px;
        }
        .p2 {
          display: block;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ffffff;
        }
        .p3 {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
    .center {
      height: 100%;
      margin-left: 161px;
      position: relative;
      ul {
        height: 100%;
        list-style: none;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .hyperlinks {
          text-decoration: none;
          display: block;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 36px;
          .li {
            position: relative;

            padding-bottom: 20px;
            position: relative;
            top: 10px;
            box-sizing: border-box;
            .menu {
              display: none;
              position: absolute;
              left: -18px;
              top: 40px;
              color: black;
              border-top: 3px solid #fdd000;
              box-shadow: 0px 0px 51px 0px #e8ecf0;
              width: fit-content;
              width: 105px;
              background-color: white;
              a {
                text-decoration: none;
                p {
                  height: 36px;
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                  text-align: center;
                  line-height: 36px;
                  &:hover {
                    color: #006fb8;
                    background: #ededed;
                  }
                }
              }
            }
            &:hover {
              .menu {
                display: block;
              }
            }
          }
        }
        li {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          white-space: nowrap;
        }
        li:hover {
          color: #fccf00;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-left: 26px;
      .login1 {
        // width: 101px;
        height: 39px;
        background: #fdd000;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #006fb8;
        text-align: center;
        cursor: pointer;
        line-height: 39px;
        margin-left: 1px;
      }
      .login1:hover {
        // width: 101px;
        height: 39px;
        background: #fdd933;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #006fb8;
        text-align: center;
        cursor: pointer;
        opacity: 0.9;
      }
      .login1:active {
        // width: 101px;
        height: 39px;
        background: #e4bb00;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #006fb8;
        text-align: center;
        cursor: pointer;
      }
      .login {
        height: 37px;
        border: 1px solid #ffffff;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 37px;
        // width: 101px;
        height: 37px;
        margin-left: 4px;
        cursor: pointer;
      }
      .login:hover {
        // width: 101px;
        height: 37px;
        border: 1px solid #c4deef;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #e6f1f8;
      }
      .login:active {
        // width: 101px;
        height: 37px;
        border: 1px solid #ffffff;
        opacity: 0.7;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fefefe;
        opacity: 0.7;
      }
      .language {
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        margin-left: 5px;
        .chese {
          margin-left: 9px;
          margin-right: 5px;
          padding-right: 5px;
          white-space: nowrap;
          cursor: pointer;
          img {
            vertical-align: middle;
          }
        }
        .english {
          margin-left: 9px;
          margin-right: 5px;
          padding-right: 5px;
          white-space: nowrap;
          cursor: pointer;
          img {
            vertical-align: middle;
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 1920px) {
  .head {
    // width: 1920px;
    width: 100%;
    // border: 1px solid red;
    .header {
      width: 1920px;
      box-sizing: border-box;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 20px;
        .img {
          width: 87px;
          height: 86px;
        }
        .txt {
          width: 440px;
          margin-left: 15px;

          .p1 {
            display: block;
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
            line-height: 26px;
          }
          .p2 {
            display: block;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
          }
          .p3 {
            font-size: d 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
